/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2020
 */
import AnalyticManager from "@/core/analytic/AnalyticManager";
// import VueFacebookPixel from 'vue-facebook-pixel'

// Vue.use(VueFacebookPixel)

// console.log("Vue.js ")
// setTimeout(() => console.log("Vue.js 2 process = ", process.version), 5000)

	// , .version


let analyticManager = new AnalyticManager()


// let amplitudeUserId = Vue.config.globalProperties.$analyticManager.getAmplitudeDeviceId()
// console.log("amplitudeUserId: = ", amplitudeUserId)

console.log("analyticManager = ", analyticManager)

export default analyticManager




